import React from 'react';
import { Skeleton, SxProps, Theme } from '@mui/material';

interface BoxBoneProps {
    /** Variante du skeleton */
    variant?: 'rectangular' | 'rounded' | 'circular';
    /** Animation */
    animation?: 'pulse' | 'wave' | false;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const BoxBone: React.FunctionComponent<BoxBoneProps> = function ({
    variant = 'rounded',
    animation = 'pulse',
    sx = {},
}) {
    return (
        <Skeleton
            variant={variant}
            animation={animation}
            role="progressbar"
            sx={sx}
        />
    );
};
